module.exports = __webpack_public_path__ + "static/media/pan2Default.c453557d.png";